import Login from '../../../pages/login/Login';
import ResetPassword from '../../../pages/reset-password/ResetPassword';
import Admins from '../../../pages/admins/Admins';
import Companies from '../../../pages/companies/Companies';
import GSPolicies from '../../../pages/policies/GSPolicies';
import FrameworkCrosswalk from '../../../pages/framework-crosswalk/FrameworkCrosswalk';
import AILogs from '../../../pages/ai-logs/AILogs';
import Profile from '../../../pages/profile/Profile';
import { Verify } from '../../../pages/verify';

export const AppUrls = {
	login: '/login',
	verify: '/verify',
	resetPassword: '/reset-password',
	createPassword: '/create-password',
	companies: '/companies',
	admins: '/company-admins',
	controls: '/controls',
	policies: '/policies',
	frameworkCrosswalk: '/framework-crosswalk',
	aiLogs: '/ai-logs',
	profile: '/profile',
};

export const AppRoutes = [
	{ type: 'unprotected', key: 'login', text: 'Login', url: AppUrls.login, component: Login },
	{ type: 'unprotected', key: 'verify', text: 'Verify', url: AppUrls.verify, component: Verify },
	{
		type: 'unprotected',
		key: 'resetPassword',
		text: 'Reset Password',
		url: AppUrls.resetPassword,
		component: ResetPassword,
	},
	{
		type: 'unprotected',
		key: 'createPassword',
		text: 'Create Password',
		url: AppUrls.createPassword,
		component: ResetPassword,
	},
	{
		type: 'protected',
		key: 'companies',
		text: 'Companies',
		url: AppUrls.companies,
		component: Companies,
	},
	{
		type: 'protected',
		key: 'admins',
		text: 'Company Admins',
		url: AppUrls.admins,
		component: Admins,
	},
	{
		type: 'protected',
		key: 'policies',
		text: 'GS Policy Library',
		url: AppUrls.policies,
		component: GSPolicies,
	},
	{
		type: 'protected',
		key: 'framework-crosswalk',
		text: 'Framework Crosswalk',
		url: AppUrls.frameworkCrosswalk,
		component: FrameworkCrosswalk,
	},
	{
		type: 'protected',
		key: 'ai-logs',
		text: 'AI Logs',
		url: AppUrls.aiLogs,
		component: AILogs,
	},
	{
		type: 'protected',
		key: 'profile',
		text: 'Profile',
		url: AppUrls.profile,
		component: Profile,
		excludeFromNavigation: true,
	},
];

export const AppUnauthorizedRoutes = [AppUrls.createPassword, AppUrls.resetPassword, AppUrls.login];
